export default "__VITE_ASSET__f9c22a08__"